// Where focus goes when the control that changed the table is gone.

// after the next paint, so the target exists in the committed DOM
export const focusAfterFrame = ref =>
  window.requestAnimationFrame(() => ref.current && ref.current.focus())

const STATE_HEADING = '.me-table-state-title'

const isUsable = element =>
  Boolean(element) &&
  element.isConnected &&
  !element.disabled &&
  element.getAttribute('aria-disabled') !== 'true'

// Focus was not moved elsewhere by the person while the request ran: it fell to the body when its control
// left the DOM, or it still sits on the control that started the request.
const focusIsFree = initiator => {
  const active = document.activeElement
  return (
    !active ||
    active === document.body ||
    !active.isConnected ||
    active === initiator
  )
}

/**
 * Once a request settles, return focus to the control that started it. When that control is gone and a
 * state surface took the rows' place, its heading takes focus instead. Requests the person did not start
 * move nothing.
 * @param {{element: ?HTMLElement, userInitiated: boolean}|null|undefined} initiator
 * @param {{current: ?HTMLElement}} unitRef the table unit
 */
export const restoreAfterRequest = (initiator, unitRef) => {
  if (!initiator || !initiator.userInitiated) return
  const { element } = initiator
  window.requestAnimationFrame(() => {
    const unit = unitRef && unitRef.current
    if (!unit || !unit.isConnected || !focusIsFree(element)) return
    if (isUsable(element)) {
      element.focus()
      return
    }
    const heading = unit.querySelector(STATE_HEADING)
    if (heading) heading.focus()
  })
}
